<template>
  <div class="offline-box flex-col aic" v-show="currObj.show" :class="offline + ''">
    <img src="../assets/images/ban.gif" alt="" class="ban vat"/>
    <div class="tip">{{currObj.tip}}</div>
    <div class="sub-tip">{{currObj.sub}}</div>
  </div>
</template>

<script>
  export default {
    name: "Offline",
    props: {
      isNoData: {
        type: Boolean,
        default: false,
      },
      show: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      currObj() {
        return this.isNoData ? {
          tip: '暂无内容',
          sub: '先看看其他课程吧!',
          show: this.show,
        } : {
          tip: '网络连接错误',
          sub: '请检查网络设置',
          show: this.offline,
        };
      },
    },
    data() {
      return {
        offline: false,
        currTop: 0,
      }
    },
    watch: {
      offline(v) {
        let dom = document.getElementById('app');
        if (v) {
          this.currTop = dom.scrollTop;
          dom.scrollTop = 0;
        } else {
          dom.scrollTop = this.currTop;
        }
      }
    },
    mounted() {
      if (!this.isNoData) {
        this.offline = navigator && !navigator.onLine ? true : false;
        document.body.ononline = () => this.offline = false;
        // document.body.onoffline = () => this.offline = true;
				window.addEventListener('offline', ()=>{
					this.offline = true
				});
      }
    },
  }
</script>

<style scoped lang="less">
  .offline-box {
    padding: 208px 0 302px;
    font-size: 14px;
    color: #666f7a;
    // background-color: #f5fcff;
    .ban {
      margin-bottom: 8px;
      width: 180px;
    }
    .tip {
      margin-bottom: 8px;
      font-size: 18px;
      color: #333f4e;
    }
  }
</style>